// Date helpers for the Reservations page.
//
// Format a Date as a calendar `YYYY-MM-DD` string using its LOCAL components.
// `d.toISOString().split('T')[0]` converts to UTC first, so in any timezone east
// of UTC (e.g. Asia/Kolkata, UTC+5:30) the early-morning window maps to the
// previous calendar day — booking and filtering reservations for the wrong day
// (issue #275). Reading the local Y/M/D components keeps the date the user
// actually picked / the true current IST day.
export function toLocalIsoDate(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function todayISO(): string {
  return toLocalIsoDate(new Date());
}
